export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.crmai.greybrain.ai';

console.log('API_BASE_URL:', API_BASE_URL);

export const API_ENDPOINTS = {
  BASE_URL: API_BASE_URL,
  AUTH: {
    LOGIN: `${API_BASE_URL}/api/auth/login`,
    REGISTER: `${API_BASE_URL}/api/auth/register`,
    LOGOUT: `${API_BASE_URL}/api/auth/logout`,
    ME: `${API_BASE_URL}/api/auth/me`,
  },
  LEADS: {
    LIST: `${API_BASE_URL}/api/leads`,
    
    ALL: `${API_BASE_URL}/api/leads/all`,
    DETAIL: (id: string) => `${API_BASE_URL}/api/leads/${id}`,
    UPDATE_STATUS: (id: string) => `${API_BASE_URL}/api/leads/${id}/status`,
    ASSIGN: (id: string) => `${API_BASE_URL}/api/leads/${id}/assign`,
  },
  ACTIONS: {
    CALL: `${API_BASE_URL}/api/action/call`,
    WHATSAPP: `${API_BASE_URL}/api/action/whatsapp`,
  },
  ADMIN: {
    META_PAGES: `${API_BASE_URL}/api/admin/meta-pages`,
    META_PAGES_TOGGLE: (page_id: string) => `${API_BASE_URL}/api/admin/meta-pages/${encodeURIComponent(page_id)}/toggle`,
    META_PAGES_DELETE: (page_id: string) => `${API_BASE_URL}/api/admin/meta-pages/${encodeURIComponent(page_id)}`,
    IVR_CONFIGS: `${API_BASE_URL}/api/admin/ivr-configs`,
    IVR_CONFIGS_DELETE: (campaign: string) => `${API_BASE_URL}/api/admin/ivr-configs/${encodeURIComponent(campaign)}`,
  },
  TELECALLERS: `${API_BASE_URL}/api/telecallers`,
  INSIGHTS: (scope: string) => `${API_BASE_URL}/api/insights?scope=${scope}`,
  WA_TEMPLATES: `${API_BASE_URL}/api/wa/templates`,
  CALL_QUEUE: {
    ACCEPT: `${API_BASE_URL}/api/call/accept`,
    REJECT: `${API_BASE_URL}/api/call/reject`,
    HANGUP: `${API_BASE_URL}/api/call/hangup`,
    QUEUE: `${API_BASE_URL}/api/call/queue`,
    ACTIVE_CALLS: `${API_BASE_URL}/api/call/active-calls`,
  },
  AGENT: {
    STATUS: `${API_BASE_URL}/api/agent/status`,
  },
  SSE: {
    QUEUE: (agent_id: string) => `${API_BASE_URL}/api/sse/queue?agent_id=${agent_id}`,
  },
  LIVEKIT: {
    ROOM: `${API_BASE_URL}/api/livekit/room`,
    TOKEN: `${API_BASE_URL}/api/livekit/token`,
    CUSTOMER_TOKEN: `${API_BASE_URL}/api/livekit/customer-token`,
  },
  TEST: {
    QUEUE_EVENT: `${API_BASE_URL}/api/test/queue-event`,
  },
};
